<div class="field-info-icon-center">
  <i
    *ngIf="hasSpec"
    [class]="iconClass"
    [attr.data-bs-toggle]="'tooltip'"
    [attr.data-bs-html]="'true'"
    [attr.data-bs-title]="getTooltipHtml()"
    [style.font-size]="'1rem'"
    [style.vertical-align]="'middle'"
    [style.color]="iconColor"
    [style.transition]="'color 0.2s'"
    (mouseenter)="onMouseEnter()"
    (mouseleave)="onMouseLeave()"
  ></i>
</div>